import request from '@/utils/request'

/**
 * 新增中心位置(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function positionAdd(data) {
  return request({
    type: 'biz',
    url: 'position/add',
    method: 'post',
    data
  })
}

/**
 * 获取中心位置(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function positionGet(data) {
  return request({
    type: 'biz',
    url: 'position/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Position.js